import Box from '@mui/material/Box';
import { Suspense } from "react";
import { Toaster } from "react-hot-toast";
import { Routes } from "react-router-dom";
import PageLoading from './components/common/PageLoading';
import RequireAuth from './contexts/RequireAuth';
import UnplannedLossesRoutes from './routes';

import 'bootstrap-icons/font/bootstrap-icons.css';
import "bootstrap/dist/css/bootstrap.min.css";
import '../src/assets/styles/Header.css';
import '../src/assets/styles/app.min.css';
import '../src/assets/styles/rsuite.css';
import './assets/styles/App.css';
import './assets/styles/primereact.css';

function App() {
  return (
    <div>
      <GlobalToaster />
      <RequireAuth>
        <Suspense fallback={<PageLoading />}>
          <Box sx={{ width: '100%', overflow: 'auto' }}>
            <Routes>
              {UnplannedLossesRoutes()}
            </Routes>
          </Box>
        </Suspense>
      </RequireAuth>
    </div>
  );
}

const GlobalToaster = () => {
  return (
    <Toaster
      containerStyle={{
        top: 110,
      }}
      position="top-center"
      reverseOrder={false}
    />
  )
}

export default App;

